import {
  select,
  takeLatest,
  put,
  call,
  all,
  takeEvery,
  throttle
} from "redux-saga/effects";
import {
  setRmBuddyTasks,
  setUnallocatedRmBuddyTasks,
  SET_RM_BUDDIES_WAREHOUSE_ID,
  SET_TASKS_DUE_DATE_FILTER,
  FETCH_RM_BUDDY_TASK_DETAIL,
  setRmBuddyTaskDetail,
  MARK_RM_BUDDY_TASK_DONE,
  TRANSFER_RM_BUDDY_TASK,
  FETCH_SUGGESTED_TRANSFER_BUDDIES,
  setSuggestedTransferBuddies,
  setCurrentRmBuddiesWarehouseId,
  SET_SELECTED_RM_BUDDY,
  setDelayedRmBuddyTasks,
  setSearchTaskResults,
  SEARCH_BY_ORDER_NUMBER_OR_SERVICE_REQ_ID,
  FETCH_PENDING_TASKS_SELECTED_RMBUDDY,
  setPendingTasksOfSelectedRMBuddy,
  VALIDATE_TRANSFER,
  setWarningWhileTransfer
} from "../actions";

import {
  getRmBuddyTasks,
  getUnallocatedTasks,
  getRmBuddyTaskDetails,
  markAsDone,
  getSuggestedTransferBuddies,
  transferTask,
  searchTasksByOrderNum,
  canTransferTasks,
  searchTasksByServiceReqId
} from "../../../api/rm-buddies/tasks";

// TODO seperate them outof geofenceto a common actions andreducer folder
import {
  setLoaderModal,
  setUserAuthenticated,
  setReplayOnAuthentication,
  setErrorToastMessage,
  setSuccessToastMessage
} from "../../geofence/actions";

import {
  rmBuddySchemaMapper,
  getRmBuddiesAndBlocksByWarehouseIdTask
} from "./rm-buddies";

import { isEmpty } from "lodash";

export function* fetchRmBuddyTasksTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const { fromDate, toDate, rmBuddyId } = yield select(({ rmBuddies }) => ({
      toDate: rmBuddies.tasksDueDateFilter.toDate.endOf("day").format(),
      fromDate: rmBuddies.tasksDueDateFilter.fromDate.endOf("day").format(),
      rmBuddyId: rmBuddies.selectedRmBuddyId
    }));
    const [allocatedTasks, unallocatedTasks] = yield all([
      call(getRmBuddyTasks, {
        warehouseId: action.payload,
        fromDate,
        toDate,
        rmBuddyId
      }),
      call(getUnallocatedTasks, { warehouseId: action.payload })
    ]);
    yield put(setRmBuddyTasks(allocatedTasks.data.list));
    yield put(
      setUnallocatedRmBuddyTasks(unallocatedTasks.data.unallocatedTasks)
    );
    yield put(setDelayedRmBuddyTasks(allocatedTasks.data.delayedTasks));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchWarehouseIdChange() {
  yield takeEvery(SET_RM_BUDDIES_WAREHOUSE_ID, fetchRmBuddyTasksTask);
}

export function* fetchRmBuddyTasksDueDateTask(action) {
  if (!action.payload) {
    return;
  }
  if (!action.payload.toDate || !action.payload.fromDate) {
    return;
  }
  yield put(setLoaderModal(true));
  console.log(action.payload);
  try {
    const { fromDate, toDate } = {
      toDate: action.payload.toDate.endOf("day").format(),
      fromDate: action.payload.fromDate.endOf("day").format()
    };
    const { warehouseId, rmBuddyId } = yield select(({ rmBuddies }) => ({
      warehouseId: rmBuddies.currentWarehouseId,
      rmBuddyId: rmBuddies.selectedRmBuddyId
    }));
    const [allocatedTasks, unallocatedTasks] = yield all([
      call(getRmBuddyTasks, {
        warehouseId,
        fromDate,
        toDate,
        rmBuddyId
      }),
      call(getUnallocatedTasks, { warehouseId })
    ]);
    yield put(setRmBuddyTasks(allocatedTasks.data.list));
    yield put(
      setUnallocatedRmBuddyTasks(unallocatedTasks.data.unallocatedTasks)
    );
    yield put(setDelayedRmBuddyTasks(allocatedTasks.data.delayedTasks));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchDueDateChange() {
  yield takeLatest(SET_TASKS_DUE_DATE_FILTER, fetchRmBuddyTasksDueDateTask);
}

export function* fetchRmBuddyTaskDetailsTask(action) {
  if (!action.payload) {
    return;
  }
  if (action.payload.length === 0) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const taskDetails = yield select(
      ({ rmBuddies }) => rmBuddies.taskDetails || []
    );
    const callArr = action.payload
      .filter(e => !taskDetails.find(t => t._id === e._id))
      .map(e => call(getRmBuddyTaskDetails, e._id));

    const result = yield all(callArr);
    console.log("", result);
    const fetchedData = result.map(e => e.data.buddyTask);
    const mergedResults = action.payload.map(e => {
      const alreadyExistingDetails = taskDetails.find(t => t._id === e._id);
      if (alreadyExistingDetails) {
        return alreadyExistingDetails;
      }
      return fetchedData.find(t => t._id === e._id);
    });
    yield put(setRmBuddyTaskDetail(mergedResults));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchTaskSelected() {
  yield takeLatest(FETCH_RM_BUDDY_TASK_DETAIL, fetchRmBuddyTaskDetailsTask);
}

export function* markRmBuddyTaskDoneTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    yield all(
      action.payload.taskIds.map(e =>
        call(markAsDone, {
          buddyTaskId: e
        })
      )
    );

    yield put(setSuccessToastMessage("Marked as done."));
    const warehouseId = yield select(
      ({ rmBuddies }) => rmBuddies.currentWarehouseId
    );

    yield call(fetchRmBuddyTasksTask, { payload: warehouseId });
    yield call(getRmBuddiesAndBlocksByWarehouseIdTask, {
      payload: warehouseId
    });
    if (action.payload.onSuccessAction) {
      yield put(action.payload.onSuccessAction);
    }
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchMarkAsDoneSelected() {
  yield takeLatest(MARK_RM_BUDDY_TASK_DONE, markRmBuddyTaskDoneTask);
}

export function* transferRmBuddyTaskTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    yield all(
      action.payload.buddyTaskIds.map(e =>
        call(transferTask, {
          buddyTaskId: e,
          rmBuddyId: action.payload.rmBuddyId
        })
      )
    );
    yield put(setSuccessToastMessage("Tasks transferred successfully."));
    const warehouseId = yield select(
      ({ rmBuddies }) => rmBuddies.currentWarehouseId
    );

    yield call(fetchRmBuddyTasksTask, { payload: warehouseId });
    yield call(getRmBuddiesAndBlocksByWarehouseIdTask, {
      payload: warehouseId
    });
    if (action.payload.onTransferAction) {
      yield put(action.payload.onTransferAction);
    }
    if (action.payload.onSuccessAction) {
      yield put(action.payload.onSuccessAction);
    }
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchTransferTaskAction() {
  yield takeLatest(TRANSFER_RM_BUDDY_TASK, transferRmBuddyTaskTask);
}

function extractReasons(obj) {
  const keys = Object.keys(obj);
  const issueMap = {
    rmBuddyAbsent: false,
    taskLimitReached: false
  };
  const reasons = [];
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i];
    if (obj[key].rmBuddyAbsent && !issueMap.rmBuddyAbsent) {
      issueMap.rmBuddyAbsent = true;
      reasons.push("RM buddy is absent on due dates of selected tasks");
    }
    if (obj[key].taskLimitReached && !issueMap.taskLimitReached) {
      issueMap.taskLimitReached = true;
      reasons.push("RM buddy task limit is reached");
    }
    if (issueMap.rmBuddyAbsent && issueMap.taskLimitReached) {
      reasons.push("Are you sure you want to transfer tasks ?");
      return reasons;
    }
  }
  reasons.push("Are you sure you want to transfer tasks ?");
  return reasons;
}

export function* validateAndTransferTasksTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const result = yield call(canTransferTasks, action.payload);
    if (isEmpty(result.data.transferIssues)) {
      yield put(setLoaderModal(false));
      yield call(transferRmBuddyTaskTask, action);
      return;
    }
    yield put(
      setWarningWhileTransfer(extractReasons(result.data.transferIssues))
    );
    yield put(setLoaderModal(false));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchTransferValidationAction() {
  yield takeLatest(VALIDATE_TRANSFER, validateAndTransferTasksTask);
}

export function* getSuggestedTransferBuddiesTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const warehouseId = yield select(
      ({ rmBuddies }) => rmBuddies.currentWarehouseId
    );
    const result = yield call(getSuggestedTransferBuddies, {
      taskId: action.payload,
      warehouseId
    });
    yield put(
      setSuggestedTransferBuddies(
        result.data.suggestedArray.map(rmBuddySchemaMapper)
      )
    );
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchFetchSuggestedBuddiesAction() {
  yield takeLatest(
    FETCH_SUGGESTED_TRANSFER_BUDDIES,
    getSuggestedTransferBuddiesTask
  );
}

export function* fetchSelectedBuddyTasksTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const { fromDate, toDate, warehouseId } = yield select(({ rmBuddies }) => ({
      toDate: rmBuddies.tasksDueDateFilter.toDate.endOf("day").format(),
      fromDate: rmBuddies.tasksDueDateFilter.fromDate.endOf("day").format(),
      warehouseId: rmBuddies.currentWarehouseId
    }));
    const [allocatedTasks, unallocatedTasks] = yield all([
      call(getRmBuddyTasks, {
        warehouseId,
        fromDate,
        toDate,
        rmBuddyId: action.payload
      }),
      call(getUnallocatedTasks, { warehouseId: action.payload })
    ]);
    yield put(setRmBuddyTasks(allocatedTasks.data.list));
    yield put(
      setUnallocatedRmBuddyTasks(unallocatedTasks.data.unallocatedTasks)
    );
    yield put(setDelayedRmBuddyTasks(allocatedTasks.data.delayedTasks));
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchSelectedBuddyIdChange() {
  yield takeLatest(SET_SELECTED_RM_BUDDY, fetchSelectedBuddyTasksTask);
}

export function* searchTasksByOrderNumberTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const { warehouseId } = yield select(({ rmBuddies }) => ({
      warehouseId: rmBuddies.currentWarehouseId
    }));
    const [tasksByOrderNumber, tasksByServiceReqId] = yield all([
      call(searchTasksByOrderNum, {
        warehouseId,
        orderNumber: action.payload
      }),
      call(searchTasksByServiceReqId, {
        serviceRequestId: action.payload
      })
    ]);
    yield put(
      setSearchTaskResults([
        ...tasksByServiceReqId.data.buddyTasks,
        ...tasksByOrderNumber.data.list
      ])
    );
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchSearchAction() {
  yield takeLatest(
    SEARCH_BY_ORDER_NUMBER_OR_SERVICE_REQ_ID,
    searchTasksByOrderNumberTask
  );
}

export function* fetchPendingTasksTask(action) {
  if (!action.payload) {
    return;
  }
  yield put(setLoaderModal(true));
  try {
    const rmBuddyId = yield select(
      ({ rmBuddies }) => rmBuddies.selectedRmBuddyId
    );
    const { fromDate, toDate } = action.payload;
    const tasks = yield call(getRmBuddyTasks, {
      fromDate: fromDate.endOf("day").format(),
      toDate: toDate.endOf("day").format(),
      rmBuddyId,
      status: "PENDING"
    });
    yield put(
      setPendingTasksOfSelectedRMBuddy([
        ...tasks.data.list,
        ...tasks.data.delayedTasks
      ])
    );
  } catch (e) {
    console.error(e);
    if (e.response.status === 401) {
      yield put(setUserAuthenticated(false));
      yield put(setReplayOnAuthentication(action));
    }
    yield put(setErrorToastMessage(e.response.data.message));
  }
  yield put(setLoaderModal(false));
}

export function* watchFetchPendingTasksOfSelectedBuddy() {
  yield throttle(
    800,
    FETCH_PENDING_TASKS_SELECTED_RMBUDDY,
    fetchPendingTasksTask
  );
}
